import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import CalendarScreen, { DispatchProps, OwnProps, StateProps } from './CalendarScreen';

import { StoreState } from 'src/store/reducers';
import { getCase, updateCase } from 'src/store/actions/case-actions';
import { getMultiSeances } from 'src/store/actions/seance-actions';
import { QueryMultiParams, QueryParams } from 'src/types/grid';
import { getProvidersSmall } from '../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.seances.inProgress,
        caseEnt: state.cases.current,
        provider: state.providers.current,
        providers: state.providers.data,
        seances: state.seances.data,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getCaseData: (id) => dispatch(getCase(id)),
        getData: (params: QueryMultiParams) => dispatch(getMultiSeances(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        updateCaseAction: (data) =>
            dispatch(
                updateCase(
                    data,
                    () => false,
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
    };
}

const CalendarScreenScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CalendarScreen);

export default CalendarScreenScreen;
